export default "__VITE_ASSET__Bqh2gyzL__"